<template>
	<div style="display: flex;flex-direction: column;width: 100%;">
		<div v-for="(item, index) in quesdata" :key="index" style="padding: 1rem 0;border-bottom: 1px solid #eee;">
			<div style="display: flex;justify-content: space-between;align-items: center;color: #333;font-weight: 500;">
				<div style="font-size: 1rem;">
					Q:{{item.title}}
				</div>
				<div>
					<img :src="showid.includes(item.id)?require('../../src/assets/imgs/user/userlevel/ret_icon.svg'):require('../../src/assets/imgs/user/userlevel/exp_icon.svg')"
							style="width: 1.2rem;height: 1.2rem;cursor: pointer;" @click="changeshow(item.id)">
				</div>
			</div>
			<transition name="" enter-active-class="fadeInDown animated transition-02s" leave-active-class="fadeOutUp animated transition-02s">
				<div style="display: flex;flex-wrap: wrap;margin-top: 1rem;color: #6A6A6A;font-size: 0.8rem;" v-if="showid.includes(item.id)">
					A:{{item.content}}
				</div>
			</transition>	
		</div>
	</div>
</template>

<script>
	import Header from '/src/components/header.vue'
	import Footer from '/src/components/footer.vue'
	import Question from '/src/components/question.vue'
	export default {
		data() {
			return {
				quesdata:[],
				showid:[]
			}
		},
		components: {
		},
		props:{
			type:0
		},
		methods: {
			getquesdata(){
				this.request({
					method: 'get',
					url: '/gci/question/list?type='+this.type,
				}).then(res => {
					this.quesdata = res.data.items
				}).catch(error => {
					console.error(error.response)
				})
			},
			changeshow(id){
				if(this.showid.includes(id)){
					// this.showid = null
					for (let i in this.showid) {
						if(this.showid[i]==id){
							this.showid.splice(i,1)
						}
					}
				}else{
					this.showid.push(id)
				}
			}
		},
		mounted() {
			this.getquesdata()
			console.info(this.type)
		}
	}
</script>

<style scoped lang="scss">
	
	.transition-02s{
		overflow: hidden;
		animation-duration: 0.4s;
	}
</style>